import { useGetStatusLazyQuery as _useGetStatusLazyQuery, useGetStatusQuery as _useGetStatusQuery, } from "../generated/graphql-types";
export const useGetStatus = (view_mode = '', orgsEnabled = false) => {
    const { data, error, loading, refetch } = _useGetStatusQuery({
        fetchPolicy: 'no-cache',
        variables: {
            viewMode: view_mode,
            orgsEnabled,
        },
    });
    return {
        error,
        loading,
        data: data?.Admin_getStatus,
        refetch,
    };
};
export const useGetStatusLazy = (view_mode = '', orgsEnabled = false) => {
    const [getStatus, { data, error, loading }] = _useGetStatusLazyQuery({
        variables: {
            viewMode: view_mode,
            orgsEnabled,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getStatus,
        getStatus,
    };
};
//# sourceMappingURL=sidebar-service.js.map